import { useState } from "react";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { apiService } from "@/lib/api-service";
import { TransitionScreen } from "@/components/platform-intro/TransitionScreen";
import { SpotlightTourScreen } from "@/components/platform-intro/SpotlightTourScreen";

export const Route = createFileRoute("/platform-intro")({
	component: PlatformIntro,
	beforeLoad: async ({ context }) => {
		if (!context.auth.isAuthenticated()) {
			throw redirect({ to: "/login" });
		}
	},
	loader: async () => {
		const session = await apiService.getSession();
		if (session?.user?.platform_intro_completed) {
			throw redirect({ to: "/" });
		}
	},
});

function PlatformIntro() {
	const [screen, setScreen] = useState<0 | 1>(0);

	if (screen === 0) {
		return <TransitionScreen onContinue={() => setScreen(1)} />;
	}

	return <SpotlightTourScreen />;
}
